import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "formulario-modelo" }
const _hoisted_2 = { class: "header-flex" }
const _hoisted_3 = { class: "ctx-proceso" }
const _hoisted_4 = {
  key: 0,
  class: "ctx-badge"
}
const _hoisted_5 = {
  key: 1,
  class: "ctx-badge"
}
const _hoisted_6 = {
  key: 2,
  class: "ctx-badge"
}
const _hoisted_7 = { class: "ayuda" }
const _hoisted_8 = {
  key: 0,
  class: "info"
}
const _hoisted_9 = {
  key: 1,
  class: "marco"
}
const _hoisted_10 = {
  key: 0,
  class: "texto-vacio"
}
const _hoisted_11 = {
  key: 1,
  class: "contenedor-tabla"
}
const _hoisted_12 = { class: "lista-tabla" }
const _hoisted_13 = { class: "nombre" }
const _hoisted_14 = {
  key: 0,
  class: "ordinal"
}
const _hoisted_15 = { class: "col-num" }
const _hoisted_16 = { class: "col-tarea" }
const _hoisted_17 = { class: "factor-selector" }
const _hoisted_18 = ["disabled", "value", "onChange"]
const _hoisted_19 = ["value"]
const _hoisted_20 = {
  key: 0,
  class: "factor-guardando"
}
const _hoisted_21 = { class: "barra-herramientas" }
const _hoisted_22 = {
  key: 0,
  class: "herramienta-grupo"
}
const _hoisted_23 = ["value"]
const _hoisted_24 = {
  key: 1,
  class: "herramienta-sep"
}
const _hoisted_25 = { class: "herramienta-grupo" }
const _hoisted_26 = { class: "bulk-fila" }
const _hoisted_27 = ["value"]
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 0,
  class: "aviso-filtro"
}
const _hoisted_30 = { class: "contenedor-tabla" }
const _hoisted_31 = { class: "lista-tabla" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = ["colspan"]
const _hoisted_34 = { class: "col-componente" }
const _hoisted_35 = {
  key: 0,
  class: "comp-ruta"
}
const _hoisted_36 = { class: "nombre" }
const _hoisted_37 = {
  key: 0,
  class: "ordinal"
}
const _hoisted_38 = ["disabled", "value", "onChange"]
const _hoisted_39 = ["value"]

import { ref, reactive, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useGestionIndicadores } from '@/store/GestionIndicadores'
import { useGestionIndicadorEvaluadores } from '@/store/GestionIndicadorEvaluadores'
import { useGestionVersiones } from '@/store/GestionVersiones'
import { useComponentes } from '@/store/GestionComponentes'
import { getProcesoByIdService } from '@/services/ProcesoAutoevaluacionService'
import { crearIndicadorEvaluadorService, eliminarIndicadorEvaluadorService } from '@/services/IndicadorEvaluadorService'
import { listarUsuarios } from '@/services/RegistroUsuariosService'
import useAutenticar from '@/store/IngresoAutenticar'
import type Indicador from '@/interfaces/Indicador'
import type Componente from '@/interfaces/Componente'
import type { Usuario } from '@/interfaces/Usuario'
import type { TareaAsignacion } from '@/interfaces/IndicadorEvaluador'
import MensajeFlotante from '@/components/MensajeFlotante.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AsignarTareasDirectorView',
  setup(__props) {

/**
 * Reparto de indicadores que hace el director de programa.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/ejecucion/:id_ejecucion/asignar-tareas` (AsignarTareasDirector) — permiso `procesos.asignar`
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const route = useRoute()
const idEjecucion = Number(route.params.id_ejecucion)

const indicadoresStore = useGestionIndicadores()
const evaluadoresStore = useGestionIndicadorEvaluadores()
const versionesStore   = useGestionVersiones()
const componentesStore = useComponentes()
const authStore        = useAutenticar()

const tareas: { id: TareaAsignacion; label: string }[] = [
  { id: 'evidencias', label: 'Subir / Aplicar Instrumento' },
  { id: 'calificar',  label: 'Calificar' }
]

const cargando      = ref(true)
const idVersion     = ref<number | null>(null)
const ambito        = ref<'institucional' | 'programa' | null>(null)
const nombreProceso = ref('Proceso de autoevaluación')
const nombreVersion = ref('')
const nombreCampus  = ref('')
const indicadores   = ref<Indicador[]>([])
const usuarios      = ref<Usuario[]>([])

const guardandoClave  = ref<string | null>(null)
const guardandoBulk   = ref(false)
const guardandoFactor = ref<number | null>(null)

const componentesPrimerNivel = ref<Componente[]>([])
const componenteFiltro       = ref<number | null>(null)
const nombreComponenteMap    = ref(new Map<number, string>())
const rutaComponenteMap      = ref(new Map<number, string[]>())
const ancestroMap            = ref(new Map<number, number>())

const usuarioBulk = ref<number | null>(null)
const tareaBulk   = ref<'evidencias' | 'calificar' | 'ambas'>('ambas')

const seleccionFactor = reactive<Record<number, number | null>>({})

const indicadoresPorFactor = computed(() => {
  const mapa = new Map<number, number[]>()
  for (const factor of componentesPrimerNivel.value) {
    if (!factor.id_componente) continue
    mapa.set(
      factor.id_componente,
      indicadores.value
        .filter(i => i.id_indicador != null && ancestroMap.value.get(i.id_componente) === factor.id_componente)
        .map(i => i.id_indicador!)
    )
  }
  return mapa
})

const seleccion          = reactive<Record<string, number | null>>({})
const asignacionPorClave = reactive<Record<string, { id: number; id_usuario: number }>>({})

const msgVisible = ref(false)
const msgTexto   = ref('')
const msgTipo    = ref<'positivo' | 'error'>('positivo')

const indicadoresFiltrados = computed(() =>
  componenteFiltro.value === null
    ? indicadores.value
    : indicadores.value.filter(i => ancestroMap.value.get(i.id_componente) === componenteFiltro.value)
)

function clave(idInd: number, tarea: TareaAsignacion): string {
  return `${idInd}:${tarea}`
}

function toast(texto: string, tipo: 'positivo' | 'error' = 'positivo') {
  msgTexto.value   = texto
  msgTipo.value    = tipo
  msgVisible.value = true
}

function formatOrdinal(ordinal: string | null | undefined): string {
  if (!ordinal) return ''
  const parts = ordinal.split('.')
  return parts.length <= 1 ? ordinal : parts.slice(1).join('.')
}

const compararOrdinal = (a: string, b: string): number => {
  const pa = a.split('.').map(n => parseInt(n, 10) || 0)
  const pb = b.split('.').map(n => parseInt(n, 10) || 0)
  const len = Math.max(pa.length, pb.length)
  for (let i = 0; i < len; i++) {
    const diff = (pa[i] ?? 0) - (pb[i] ?? 0)
    if (diff !== 0) return diff
  }
  return 0
}

const flattenNombres = (nodo: Componente, mapa: Map<number, string>, rutaMapa: Map<number, string[]>, ancestros: string[] = []): void => {
  const ord = formatOrdinal(nodo.ordinal)
  const label = ord ? `${ord}. ${nodo.nombre ?? ''}` : (nodo.nombre ?? '')
  if (nodo.id_componente) {
    mapa.set(nodo.id_componente, label)
    rutaMapa.set(nodo.id_componente, [...ancestros])
  }
  for (const h of nodo.children ?? []) flattenNombres(h, mapa, rutaMapa, [...ancestros, label])
}

const mapAncestros = (nodos: Componente[], ancestroId: number, mapa: Map<number, number>): void => {
  for (const n of nodos) {
    if (n.id_componente) mapa.set(n.id_componente, ancestroId)
    if (n.children?.length) mapAncestros(n.children, ancestroId, mapa)
  }
}

async function onChange(idInd: number, tarea: TareaAsignacion, ev: Event) {
  const val = (ev.target as HTMLSelectElement).value
  await guardarCelda(idInd, tarea, val ? Number(val) : null)
}

async function guardarCeldaBulk(idInd: number, tarea: TareaAsignacion, nuevo: number | null) {
  const key       = clave(idInd, tarea)
  const existente = asignacionPorClave[key]
  if ((existente?.id_usuario ?? null) === nuevo) return

  if (existente) {
    const del = await eliminarIndicadorEvaluadorService(existente.id)
    if (!del.ok) return
    delete asignacionPorClave[key]
  }
  if (nuevo) {
    const r = await crearIndicadorEvaluadorService({
      id_version:      idVersion.value!,
      id_ejecucion:    idEjecucion,
      id_indicador:    idInd,
      id_usuario:      nuevo,
      tarea,
      id_asignado_por: authStore.usuarioActual?.id ?? null
    })
    if (r.ok && r.data?.id) {
      asignacionPorClave[key] = { id: r.data.id, id_usuario: nuevo }
      seleccion[key] = nuevo
    } else {
      seleccion[key] = null
    }
  } else {
    seleccion[key] = null
  }
}

async function guardarCelda(idInd: number, tarea: TareaAsignacion, nuevo: number | null) {
  const key      = clave(idInd, tarea)
  const existente = asignacionPorClave[key]
  if ((existente?.id_usuario ?? null) === nuevo) return

  guardandoClave.value = key
  const previo = seleccion[key] ?? null

  if (existente) {
    const del = await evaluadoresStore.eliminar(existente.id)
    if (!del.ok) {
      guardandoClave.value = null
      toast('No se pudo actualizar la asignación.', 'error')
      seleccion[key] = previo
      return
    }
    delete asignacionPorClave[key]
  }

  if (nuevo) {
    const r = await evaluadoresStore.asignar({
      id_version:      idVersion.value!,
      id_ejecucion:    idEjecucion,
      id_indicador:    idInd,
      id_usuario:      nuevo,
      tarea,
      id_asignado_por: authStore.usuarioActual?.id ?? null
    })
    if (r.ok && r.data?.id) {
      asignacionPorClave[key] = { id: r.data.id, id_usuario: nuevo }
      seleccion[key] = nuevo
      toast('Asignación guardada.')
    } else {
      seleccion[key] = null
      toast('No se pudo guardar la asignación.', 'error')
    }
  } else {
    seleccion[key] = null
    toast('Asignación retirada.')
  }

  guardandoClave.value = null
}

function derivarSeleccionFactores() {
  for (const factor of componentesPrimerNivel.value) {
    if (!factor.id_componente) continue
    const inds = indicadoresPorFactor.value.get(factor.id_componente) ?? []
    if (!inds.length) { seleccionFactor[factor.id_componente] = null; continue }
    const primero = seleccion[clave(inds[0], 'calificar')] ?? null
    seleccionFactor[factor.id_componente] = inds.every(
      id => (seleccion[clave(id, 'calificar')] ?? null) === primero
    ) ? primero : null
  }
}

async function onChangeFactor(idFactor: number, ev: Event) {
  const val = (ev.target as HTMLSelectElement).value
  await asignarPorFactor(idFactor, val ? Number(val) : null)
}

async function asignarPorFactor(idFactor: number, idUsuario: number | null) {
  if (guardandoFactor.value !== null) return
  guardandoFactor.value = idFactor
  seleccionFactor[idFactor] = idUsuario
  try {
    const inds = indicadoresPorFactor.value.get(idFactor) ?? []
    const pares = inds.flatMap(idInd =>
      (['evidencias', 'calificar'] as TareaAsignacion[]).map(t => ({ idInd, tarea: t }))
    )
    for (let i = 0; i < pares.length; i += 10) {
      const lote = pares.slice(i, i + 10)
      await Promise.allSettled(
        lote.map(({ idInd, tarea }) => guardarCeldaBulk(idInd, tarea, idUsuario))
      )
    }
    toast(idUsuario ? 'Responsable asignado.' : 'Asignación retirada.')
  } catch {
    toast('Error al asignar el responsable.', 'error')
    seleccionFactor[idFactor] = null
  } finally {
    guardandoFactor.value = null
  }
}

async function asignarMasivo() {
  if (!usuarioBulk.value || guardandoBulk.value) return
  guardandoBulk.value = true
  try {
    const tareasSeleccionadas: TareaAsignacion[] =
      tareaBulk.value === 'ambas' ? ['evidencias', 'calificar'] : [tareaBulk.value]
    const pares = indicadoresFiltrados.value.flatMap(ind =>
      tareasSeleccionadas.map(t => ({ idInd: ind.id_indicador!, tarea: t }))
    )
    for (let i = 0; i < pares.length; i += 10) {
      const lote = pares.slice(i, i + 10)
      await Promise.allSettled(
        lote.map(({ idInd, tarea }) => guardarCeldaBulk(idInd, tarea, usuarioBulk.value!))
      )
    }
    toast('Asignación masiva completada.')
  } catch {
    toast('Error durante la asignación masiva.', 'error')
  } finally {
    guardandoBulk.value = false
  }
}

onMounted(async () => {
  try {
    const [proceso, usrs] = await Promise.all([
      getProcesoByIdService(idEjecucion),
      listarUsuarios(),
      indicadoresStore.cargarTodos()
    ])
    usuarios.value = usrs

    if (!proceso) {
      toast('No se encontró la ejecución.', 'error')
      return
    }

    idVersion.value     = proceso.id_version
    ambito.value        = proceso.ambito
    nombreProceso.value = `${proceso.ambito === 'programa' ? 'Programa' : 'Institucional'} · ${proceso.periodo}`
    nombreCampus.value  = proceso.campus?.nombre ?? ''

    const version = await versionesStore.getVersionById(proceso.id_version)
    nombreVersion.value = version?.nombre ?? ''

    indicadores.value = indicadoresStore.indicadores
      .filter(i => i.id_version === idVersion.value && i.id_indicador != null)
      .sort((a, b) => ((a.ordinal ?? 9999) - (b.ordinal ?? 9999)) || (a.id_indicador! - b.id_indicador!))

    // Build component name map and first-level ancestor map
    if (version?.id_modelo) {
      const raiz = await componentesStore.cargarRaizPorModelo(version.id_modelo)
      if (raiz?.id_componente) {
        await componentesStore.cargarArbolDesdeRaiz(raiz.id_componente)
        const raizNodo = componentesStore.componentes[0]
        if (raizNodo?.children?.length) {
          componentesPrimerNivel.value = [...raizNodo.children].sort(
            (a, b) => compararOrdinal(a.ordinal ?? '0', b.ordinal ?? '0')
          )
          const nMap = new Map<number, string>()
          const rMap = new Map<number, string[]>()
          const aMap = new Map<number, number>()
          for (const factor of raizNodo.children) {
            if (!factor.id_componente) continue
            flattenNombres(factor, nMap, rMap)
            aMap.set(factor.id_componente, factor.id_componente)
            mapAncestros(factor.children ?? [], factor.id_componente, aMap)
          }
          nombreComponenteMap.value = nMap
          rutaComponenteMap.value = rMap
          ancestroMap.value = aMap
        }
      }
    }

    await evaluadoresStore.cargar({ id_version: idVersion.value!, id_ejecucion: idEjecucion })
    for (const a of evaluadoresStore.asignaciones) {
      if (a.id_indicador == null || a.tarea == null || a.id == null) continue
      const key = clave(a.id_indicador, a.tarea)
      seleccion[key] = a.id_usuario
      asignacionPorClave[key] = { id: a.id, id_usuario: a.id_usuario }
    }
    if (proceso.ambito === 'institucional') derivarSeleccionFactores()
  } catch (e: any) {
    toast(e?.message || 'Error al cargar los datos.', 'error')
  } finally {
    cargando.value = false
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[5] || (_cache[5] = _createElementVNode("h1", null, "Asignar tareas por indicador", -1)),
        _createElementVNode("div", _hoisted_3, [
          (nombreProceso.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(nombreProceso.value), 1))
            : _createCommentVNode("", true),
          (nombreVersion.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(nombreVersion.value), 1))
            : _createCommentVNode("", true),
          (ambito.value === 'institucional' && nombreCampus.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Campus: " + _toDisplayString(nombreCampus.value), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("button", {
        class: "btn salir",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'ProcesoAutoevaluacion' })))
      }, "Volver")
    ]),
    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "divider" }, null, -1)),
    _createElementVNode("p", _hoisted_7, [
      (ambito.value === 'institucional')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(" Asigna un responsable por factor. El sistema asignará a esa persona en todos los indicadores del factor, para subir evidencias y calificar. ")
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[6] || (_cache[6] = _createTextVNode(" Asigna, por indicador, quién ")),
            _cache[7] || (_cache[7] = _createElementVNode("b", null, "sube evidencias o aplica instrumentos", -1)),
            _cache[8] || (_cache[8] = _createTextVNode(" y quién ")),
            _cache[9] || (_cache[9] = _createElementVNode("b", null, "califica", -1)),
            _cache[10] || (_cache[10] = _createTextVNode(". Los cambios se guardan al seleccionar. "))
          ], 64))
    ]),
    (cargando.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Cargando indicadores y usuarios…"))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (!indicadores.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, "No hay indicadores registrados para esta versión."))
            : (ambito.value === 'institucional')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("table", _hoisted_12, [
                    _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Factores"),
                        _createElementVNode("th", { class: "col-num-th" }, "Indicadores"),
                        _createElementVNode("th", { class: "col-tarea" }, "Responsable")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(componentesPrimerNivel.value, (factor) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: factor.id_componente
                        }, [
                          _createElementVNode("td", _hoisted_13, [
                            (formatOrdinal(factor.ordinal))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(formatOrdinal(factor.ordinal)), 1))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(factor.nombre), 1)
                          ]),
                          _createElementVNode("td", _hoisted_15, _toDisplayString(indicadoresPorFactor.value.get(factor.id_componente!)?.length ?? 0), 1),
                          _createElementVNode("td", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("select", {
                                class: "input-select",
                                disabled: guardandoFactor.value === factor.id_componente,
                                value: seleccionFactor[factor.id_componente!] ?? '',
                                onChange: ($event: any) => (onChangeFactor(factor.id_componente!, $event))
                              }, [
                                _cache[11] || (_cache[11] = _createElementVNode("option", { value: "" }, "— Sin asignar —", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usuarios.value, (u) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: u.id,
                                    value: u.id
                                  }, _toDisplayString(u.name), 9, _hoisted_19))
                                }), 128))
                              ], 40, _hoisted_18),
                              (guardandoFactor.value === factor.id_componente)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Guardando…"))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("div", _hoisted_21, [
                    (componentesPrimerNivel.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _cache[14] || (_cache[14] = _createElementVNode("span", { class: "herramienta-label" }, "Filtrar por factor", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((componenteFiltro).value = $event)),
                            class: "input-select input-select-sm"
                          }, [
                            _cache[13] || (_cache[13] = _createElementVNode("option", { value: null }, "Todos", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(componentesPrimerNivel.value, (c) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: c.id_componente,
                                value: c.id_componente
                              }, _toDisplayString(formatOrdinal(c.ordinal) ? formatOrdinal(c.ordinal) + '. ' + c.nombre : c.nombre), 9, _hoisted_23))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, componenteFiltro.value]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (componentesPrimerNivel.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_25, [
                      _cache[17] || (_cache[17] = _createElementVNode("span", { class: "herramienta-label" }, "Asignación masiva", -1)),
                      _createElementVNode("div", _hoisted_26, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((usuarioBulk).value = $event)),
                          class: "input-select input-select-sm"
                        }, [
                          _cache[15] || (_cache[15] = _createElementVNode("option", {
                            value: null,
                            disabled: ""
                          }, "— Selecciona usuario —", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usuarios.value, (u) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: u.id,
                              value: u.id
                            }, _toDisplayString(u.name), 9, _hoisted_27))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, usuarioBulk.value]
                        ]),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((tareaBulk).value = $event)),
                          class: "input-select input-select-sm"
                        }, _cache[16] || (_cache[16] = [
                          _createElementVNode("option", { value: "ambas" }, "Ambas tareas", -1),
                          _createElementVNode("option", { value: "evidencias" }, "Subir / Aplicar", -1),
                          _createElementVNode("option", { value: "calificar" }, "Calificar", -1)
                        ]), 512), [
                          [_vModelSelect, tareaBulk.value]
                        ]),
                        _createElementVNode("button", {
                          class: "btn guardar",
                          disabled: !usuarioBulk.value || guardandoBulk.value,
                          onClick: asignarMasivo
                        }, _toDisplayString(guardandoBulk.value ? 'Asignando...' : componenteFiltro.value !== null ? 'Asignar visibles' : 'Asignar todos'), 9, _hoisted_28)
                      ]),
                      (componenteFiltro.value !== null)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_29, " Solo se asignarán los " + _toDisplayString(indicadoresFiltrados.value.length) + " indicador(es) del componente seleccionado. Para asignar todos, quita el filtro. ", 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("table", _hoisted_31, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _cache[18] || (_cache[18] = _createElementVNode("th", { class: "col-componente-th" }, "Elementos", -1)),
                          _cache[19] || (_cache[19] = _createElementVNode("th", null, "Indicador", -1)),
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tareas, (t) => {
                            return _createElementVNode("th", {
                              key: t.id,
                              class: "col-tarea"
                            }, _toDisplayString(t.label), 1)
                          }), 64))
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (indicadoresFiltrados.value.length === 0)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_32, [
                              _createElementVNode("td", {
                                colspan: 2 + tareas.length,
                                class: "texto-vacio-celda"
                              }, " No hay indicadores para el componente seleccionado. ", 8, _hoisted_33)
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(indicadoresFiltrados.value, (ind) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: ind.id_indicador
                          }, [
                            _createElementVNode("td", _hoisted_34, [
                              (rutaComponenteMap.value.get(ind.id_componente)?.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(rutaComponenteMap.value.get(ind.id_componente)!.join(' › ')), 1))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(nombreComponenteMap.value.get(ind.id_componente) ?? '—'), 1)
                            ]),
                            _createElementVNode("td", _hoisted_36, [
                              (ind.ordinal)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(ind.ordinal), 1))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(ind.enunciado || ('Indicador #' + ind.id_indicador)), 1)
                            ]),
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tareas, (t) => {
                              return _createElementVNode("td", {
                                key: t.id,
                                class: "col-tarea"
                              }, [
                                _createElementVNode("select", {
                                  class: "input-select",
                                  disabled: guardandoClave.value === clave(ind.id_indicador!, t.id) || guardandoBulk.value,
                                  value: seleccion[clave(ind.id_indicador!, t.id)] ?? '',
                                  onChange: ($event: any) => (onChange(ind.id_indicador!, t.id, $event))
                                }, [
                                  _cache[20] || (_cache[20] = _createElementVNode("option", { value: "" }, "— Sin asignar —", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usuarios.value, (u) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: u.id,
                                      value: u.id
                                    }, _toDisplayString(u.name), 9, _hoisted_39))
                                  }), 128))
                                ], 40, _hoisted_38)
                              ])
                            }), 64))
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ], 64))
        ])),
    _createVNode(MensajeFlotante, {
      visible: msgVisible.value,
      mensaje: msgTexto.value,
      tipo: msgTipo.value,
      onCerrar: _cache[4] || (_cache[4] = ($event: any) => (msgVisible.value = false))
    }, null, 8, ["visible", "mensaje", "tipo"])
  ]))
}
}

})